// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormFieldStyle } from "@insite/mobius/FormField";
import { pdpProductPriceAndActionsStyle } from "@rpsc/App/Components/Product/PdpProductPriceAndActions";
import { color, hideElementOnPrint, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

pdpProductPriceAndActionsStyle.productGridContainer = {
    container: {
        css: css`
            border: none;
            padding: 0;
            max-width: none;
            ${xScreen("lte", "md")} {
                max-width: none;
            }
        `,
    },
    info: {
        css: css`
            ${FormFieldStyle} {
                margin-top: 0;
            }
            & > div {
                display: flex;
                flex-direction: column;
                gap: 12px;
            }
            margin-bottom: 16px;
            &:empty {
                display: none;
            }
        `,
    },
    addToList: {
        css: css`
            justify-content: end;
        `,
    },
    availability: {
        css: css`
            margin: 0;
        `,
    },
    price: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 4px;
            margin-bottom: 8px;
        `,
    },
};

pdpProductPriceAndActionsStyle.productPrice = {
    wrapper: {
        css: css`
            width: 100%;
            margin-bottom: 0;
        `,
    },
    price: {
        priceText: {
            css: css`
                margin: 0;
                font-size: 20px;
                line-height: 28px;
            `,
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                size: 14,
                lineHeight: "22px",
            },
        },
    },
};

pdpProductPriceAndActionsStyle.divider = {
    css: css`
        border-top: 1px solid ${color("common.border")};
        margin: 12px 0;
        width: 100%;

        ${hideElementOnPrint}
    `,
};
